export default __webpack_public_path__ + "static/media/dark.c8000022.svg";